'use client'

import { useAppRouter } from '@/components/Link'
import { useExistingOrderController } from '@/components/page-specific/catering/supplier-menu/states/useExistingOrder'
import { useExistingOrderEntry } from '@/components/page-specific/catering/supplier-menu/states/useExistingOrder/useExistingOrderEntry'

import { useSearchParams } from 'next/navigation'
import { useCallback } from 'react'

type Props = {
  vendorId?: string
}

export function ExistingOrderController({ vendorId }: Props) {
  const router = useAppRouter()
  const searchParams = useSearchParams()
  const orderIdParam = searchParams?.get('orderId') || ''

  const handleExistingOrderSave = useCallback(
    ({ orderId }: { orderId: string }) => {
      router.replace(`/order/confirmation?orderId=${orderId}`)
    },
    [router],
  )

  const { orderLoadFailed } = useExistingOrderController({
    orderId: orderIdParam || undefined,
    vendorId,
    onSuccessfulSave: orderIdParam ? handleExistingOrderSave : undefined,
  })
  useExistingOrderEntry({ orderId: orderIdParam, orderLoadFailed })

  return null
}
